(function () {
  function isTestMode() {
    return String(localStorage.getItem('cse_access_mode') || '').toUpperCase() === 'TEST';
  }

  function applyCseGuard() {
    if (!isTestMode()) return;

    document
      .querySelectorAll(
        '.accelerated-checkout-block,' +
        '.cart__checkout-button,' +
        '.additional-checkout-buttons,' +
        'shopify-accelerated-checkout,' +
        'shopify-accelerated-checkout-cart,' +
        '[name="checkout"],' +
        '#checkout'
      )
      .forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
      });
  }

  /* Dès que le formulaire d'accès est envoyé,
     on mémorise immédiatement TEST avant toute autre action. */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!form || form.id !== 'cse-access-form') return;

      const input = form.querySelector('[name="code"]');
      const code = String(input?.value || '').trim().toUpperCase();

      if (code.startsWith('TEST-')) {
        localStorage.setItem('cse_access_mode', 'TEST');
        localStorage.setItem('cse_access_code', code);
      } else {
        localStorage.removeItem('cse_access_mode');
        localStorage.removeItem('cse_access_code');
        localStorage.removeItem('cse_access_client');
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCseGuard);
  } else {
    applyCseGuard();
  }

  new MutationObserver(applyCseGuard).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* PRE-REMPLISSAGE CODE TEST DEPUIS URL */
(function () {
  const params = new URLSearchParams(window.location.search);
  const codeUrl = String(params.get('code') || '').trim().toUpperCase();

  if (!codeUrl) return;

  function remplirCodeTest() {
    const input = document.getElementById('pm-access-code');

    if (!input) return;

    if (input.value !== codeUrl) {
      input.value = codeUrl;
      input.defaultValue = codeUrl;
      input.setAttribute('value', codeUrl);

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }
  }

  remplirCodeTest();

  document.addEventListener(
    'DOMContentLoaded',
    remplirCodeTest
  );

  window.addEventListener(
    'pageshow',
    remplirCodeTest
  );

  const observer = new MutationObserver(remplirCodeTest);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  const interval = setInterval(remplirCodeTest, 100);

  setTimeout(() => {
    clearInterval(interval);
    observer.disconnect();
    remplirCodeTest();
  }, 5000);
})();